import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { ICheckoutShopData } from 'models/cart/checkoutshopdata';
import { imgSrcAttributes, thumbUrl } from 'helpers/common';

require('./style.css');

interface IProps {
	data: ICheckoutShopData;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopData extends React.Component<IProps, {}> {
	/** --------------RENDER ----------------------- */
	public render() {
		const { data } = this.props;

		let picture = thumbUrl(data.picture);
		if (!picture) {
			picture = require('containers/Html/images/defaultShop.svg');
		}

		return (
			<div className="cartShopData">
				<div className="imageWrapper">
					<img {...imgSrcAttributes(picture)} />
				</div>
				<div className="cartShopInfo">
					<div className="name">{data.name}</div>
					<div className="location">{data.location}</div>
				</div>
			</div>
		);
	}
}

export { ShopData };
